import { Body, Spacer } from '@spritz-finance/ui'
import React from 'react'
import { VerifiedBadge } from '../../components/badges/VerifiedBadge'
import { Card } from '../../components/Layout/Card'
import { Row } from '../../components/Layout/Row'
import { useIdentityVerification } from '../verification/useIdentityVerification'

export const IdentityVerification: React.VFC = () => {
    const { isVerified } = useIdentityVerification()

    return (
        <>
            {isVerified && (
                <Card>
                    <Row align="space-between">
                        <Body.SmBold>Identity status</Body.SmBold>
                        <Spacer width={16} />
                        <VerifiedBadge verified={true} />
                    </Row>
                </Card>
            )}
        </>
    )
}
